<template>
  <el-table-column
    prop="birth_name"
    label="Születési név"
    sortable="custom"
    min-width="200"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.birth_name || '-' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'birth_name',
  };
</script>
